import { httpPost } from 'utils';

interface ContactUsParams {
  subject: string;
  message: string;
  contactMethod: string;
  contactMethodValue: string;

  accountName?: string;
  accountNumber?: string;
  amount?: string;
  bic?: string;
  iban?: string;
  sortCode?: string;
  currencyType?: string;
}

export interface ContactUsResult {
  isSuccess: boolean;
}

export const contactUsApi = (config?: ContactUsParams) => {
  return httpPost<ContactUsResult, ContactUsParams>('portal/ContactUs', config);
};
